import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, DynamicForm, FieldVariant, MultiSelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { getSingleFieldObjectFactory } from '@/components/form-builder/utils/single-field-factory';
import { DacRepository } from '@/store/dac-state/dac-state.repository';

interface getDACCommiteeMemberDialogProps {
  store: DacRepository;
  members: SelectOption[];
  validate: () => void;
}

export const getDACCommiteeMemberDialog = ({ store, members, validate }: getDACCommiteeMemberDialogProps): DialogObject => {
  const committeField: DynamicField<MultiSelectFieldProps> = {
    label: 'dac.form.committee-member',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'dac.form.placeholders.committee-member',
      options: members,
      value: store.getObservable('comMemberSelected'),
      onSelectChange: (value: any) => {
        store.set('comMemberSelected', value);
        store.setNested('dto', 'assigneeUserId', value.code);
      },
    },
  };
  const formObject: DynamicForm = getSingleFieldObjectFactory(committeField);
  return {
    title: 'dac.form.committee-member',
    actions: [
      {
        label: 'dac.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
  };
};
